import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TBeneficiaryDetails, TBorrowerDetails } from "../types";


type TinitialState = {
    loanAccNo: number;
    paymentId: number;
    loanId: string;
    comments: string;
    loans: TBorrowerLoanInfo[],
};

export type TBorrowerLoanInfo = {
    loanId: string;
    emiDate: string;
    outstanding: number;
}

const initialState: TinitialState = {
    paymentId: 0,
    loanId: "",
    comments: "",
    loans: [],
    loanAccNo: 0
};

const loanMovePayment = createSlice({
    name: "loanMovePayment",
    initialState: initialState,
    reducers: {
        setLoanMovePayment: (state, action: PayloadAction<{
            paymentId: number;
            loanAccNo: number;
        }>) => {
            return {
                ...initialState,
                paymentId: action.payload.paymentId,
                loanAccNo: action.payload.loanAccNo,
            };
        },
        setLoans: (state, action: PayloadAction<{
            loans: TBorrowerLoanInfo[];
        }>) => {
            state.loans = action.payload.loans;
        },
        setLoanId: (state, action: PayloadAction<{
            loanId: string;
        }>) => {
            state.loanId = action.payload.loanId;
        },
        setComments: (state, action: PayloadAction<{
            comments: string;
        }>) => {
            state.comments = action.payload.comments;
        }
    },
});

export const {
    setLoanMovePayment,
    setLoans,
    setLoanId,
    setComments,
} = loanMovePayment.actions;

export default loanMovePayment.reducer;
